<div class="page-header">
  <div class="page-header__titles">
    <h1 class="page-title">Sessions</h1>
    <p class="page-subtitle">Manage active user sessions</p>
  </div>
</div>

<app-table
  [data]="sessionState.sessions()"
  [columns]="sessionColumns"
  [config]="sessionConfig"
  [pagination]="sessionPagination"
  (sortChange)="onSortChange($event)"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (searchChange)="onSearchChange($event)"
  (dateRangeChange)="onDateRangeChange($event)"></app-table>
